<div class="dialog-content">

  <!-- CONTENT -->
  <mat-dialog-content class="dialog-content__mat-dialog-content">

    <ng-content></ng-content>

  </mat-dialog-content>

</div>